<template>
<div :class="['h100', 'lnb-nav']">
  <div class="search mr-b10">
    <w-search-field @search="filterTree"/>
  </div>
  <div class="center">
    <el-radio-group v-model="apmTreeType" class="ordinary">
      <el-radio-button label="instance">인스턴스</el-radio-button>
      <el-radio-button label="application">어플리케이션</el-radio-button>
      <el-radio-button label="keyTrs">비즈니스</el-radio-button>
    </el-radio-group>
  </div>
  <article class="category-item">
    <el-scrollbar class="tree-wrapper">
      <el-tree v-loading="loading" :ref="treeRef" :data="treeData" :props="defaultProps" :node-key="defaultProps.treeKey" default-expand-all :expand-on-click-node="false" highlight-current :filter-node-method="filterNode" @node-click="onClickNode">
        <span class="el-tree-node__label" slot-scope="{ node, data }">
          <span :class="getTypeClass(data)">{{ data.label }}</span>
        </span>
      </el-tree>
    </el-scrollbar>
  </article>
</div>
</template>

<script>
import { isEmpty } from 'lodash';
import { defaultProps } from '@/constants/tree';
import TreeFilter from '@/mixins/tree/filter';
import TreeRouter from '@/mixins/apm/tree-router';
import ApmAPI from '@/api/apm/common';
import WSearchField from '@/components/form/SearchField';

export default {
  name: 'WApmTree',
  components: {
    WSearchField,
  },
  mixins: [TreeFilter, TreeRouter],
  data() {
    return {
      defaultProps,
      loading: false,
      apmTreeType: null,
    };
  },
  computed: {
    selectedTreeKey() {
      return this.$store.state.apm.selectedTreeKey;
    },
  },
  watch: {
    treeType: {
      immediate: true,
      handler(type) {
        this.apmTreeType = type;
      },
    },
    apmTreeType: {
      immediate: true,
      handler(type) {
        if (isEmpty(type)) {
          return;
        }
        this.$store.dispatch('setTreeType', type);
        this.loadApmTree();
        this.$nextTick(() => {
          this.routeByTreeKey(this.treeRef, this.getDefaultTreeKey(), true);
        });
      },
    },
    /**
     * 각 화면 테이블에서 선택된 항목을 트리에서 선택하여 화면전환한다.
     * @param  {[type]} treeKey [description]
     * @return {[type]}         [description]
     * @author jda
     */
    selectedTreeKey(treeKey) {
      if (isEmpty(treeKey)) {
        return;
      }
      this.$refs[this.treeRef].setCurrentKey(treeKey);
      this.routeByTreeKey(this.treeRef, treeKey);
    },
  },
  methods: {
    /**
     * 노드가 아닐 경우 group class 적용
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     * @author jda
     */
    getTypeClass(data) {
      return data.type === 'group' || data.type === 'domain' ? 'group' : null;
    },
    /**
     * 트리 대상 선택 시 화면 전환
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     * @author jda
     */
    onClickNode(data) {
      this.routeByTreeKey(this.treeRef, data[this.defaultProps.treeKey]);
    },
    /**
     * APM 트리를 로드한다.
     * @return {[type]} [description]
     * @author jda
     */
    loadApmTree() {
      this.loading = true;
      ApmAPI.getApmTreeByType(this.apmTreeType).then((response) => {
        this.loading = false;
        if (response.data.success) {
          this.treeData = response.data.children;
        } else {
          this.treeData = [];
        }
        this.$store.dispatch('setCommonTreeData', this.treeData);
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variable.scss';

.h100 {
  height: 100%;
}
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-tree-node {
  .el-tree-node__label {
    .group {
      font-family: 'Lato', 'Noto Sans KR', sans-serif;
      font-size: 14px;
      font-weight: 500;
      line-height: 22px !important;
    }
  }

  & + :not(.is-current) {
    & > .el-tree-node__label {
      .group {
        color: $deepgray;
      }
    }
  }

  &.is-current {
    & > .el-tree-node__content .el-tree-node__label {
      color: $lightblue;
      font-weight: 600;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/apm/components/tree/index.vue